module.exports = __webpack_public_path__ + "friend11.png?c5d8e47614fed86c5bfb9471acdb3297";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend11.png
// module id = 484
// module chunks = 0